module.exports = __webpack_public_path__ + "img/category-Horror.dfc1153b.svg";